export const eventTypes = {
  info: 'info',
  message: 'message',
  participant: 'participant',
  system: 'system',
} as const

export const payloadTypes = {
  choicePrompt: 'choice_prompt',
  text: 'text',
  image: 'image',
  video: 'video',
  participant: 'participant',
  divider: 'divider',
  translation: 'translation',
  message: 'message',
  countdown: 'countdown',
  upload: 'upload',
  splash: 'splash',
}

export const entryTypes = {
  text: 'text',
  upload: 'upload',
}

export const readStates = {
  received: 'received',
  read: 'read',
}

export const actionTypes = {
  pickChoice: 'pick_choice',
  navigate: 'navigate',
  custom: 'custom',
  typing: 'typing',
  read: 'read',
  detachService: 'detach_service',
  interactivityUpdate: 'interactivity_update',
  dismiss: 'dismiss',
  sendTranscript: 'send_transcript',
  setTopic: 'set_topic',
  setTranslation: 'set_translation',
  setContext: 'set_context',
  clickCard: 'click_card',
}

export const TRANSLATION_PROPOSAL = 'translation_proposal'

export const dismissTypes = {
  resumeConversationPrompt: 'resume_conversation_prompt',
  translationProposal: TRANSLATION_PROPOSAL,
} as const

export const sourceTypes = {
  translationProposal: TRANSLATION_PROPOSAL,
  translationChoice: 'translation_choice',
  windowApi: 'window_api',
} as const

export const ariaLiveLevels = {
  assertive: 'assertive',
  polite: 'polite',
} as const

export const dividerKeys = {
  new_topic: 'newTopic',
  new_translation: 'newTranslation',
}

export const featureKeys = {
  cobrowsing: 'cobrowsing',
  extraMenuItem: 'extraMenuItem',
  sendTranscript: 'sendTranscript',
  translation: 'translation',
  typingPeekahead: 'typingPeekahead',
  uploads: 'uploads',
  webNotifications: 'webNotifications',
}

export const cardTypes = {
  ask: 'ask',
  navigate: 'navigate',
  topic: 'topic',
} as const
